<script setup lang="ts">
import Gauge from '../parts/Gauge.vue';
import MetricBreakdown from './parts/MetricBreakdown.vue';
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';
defineProps<{
  hasNoData?: boolean;
  inPopup?: boolean;
  title?: string;
}>();

const emit = defineEmits<{
  (event: 'showDetails'): void;
}>();
</script>
<template>
  <div class="relative h-full flex flex-col rounded-[8px]">
    <div
      v-if="hasNoData"
      class="absolute left-0 text-center w-full text-[#828282] xl:text-3 font-family[Roboto] xl:line-height-1rem xs:text-4 xs:line-height-1.5rem"
      :class="{
        'top-20%': inPopup,
        'top-30%': !inPopup,
      }"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="xl:max-w-[200px] m-auto xs:max-w-[240px]">
        <span v-if="inPopup">
          Nothing to see here. You can try changing the
          <strong>filter</strong> to see some data.
        </span>
        <span v-else>
          Nothing to see here. <br />
          You can try changing the <strong>filter</strong> or checking the <strong>View More</strong> to see other
          programs.
        </span>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between mt-2">
      <div class="mr-4 3xl:mt-8" v-if="!inPopup">
        <div
          v-if="title"
          class="mr-4 font-bold xl:text-4 2xl:text-5 3xl:text-10 xs:text-5 3xl:mt-8 text-[#4F4F4F] font-family[Poppins]"
        >
          {{ title }}
        </div>
        <div v-else class="inline-block loading-gradient h-50% w-33% rounded-2"></div>
      </div>
      <div
        v-if="!inPopup"
        @click="emit('showDetails')"
        id="show-primary-metric-modal-button"
        class="xs:hidden lg:flex text-3 mr-4 font-[Roboto] text-[#C73362] underline cursor-pointer"
      >
        View More
      </div>
      <a
        v-if="!inPopup"
        @click="emit('showDetails')"
        id="show-primary-metric-modal-button-mobile"
        class="lg:hidden inline ml-auto i-mdi-chevron-right bg-[#4F4F4F] w-8 h-8 cursor-pointer"
      ></a>
    </div>
    <div
      class="mt-6 mb-6 flex items-center justify-between"
      :class="{
        'sm:flex-row xs:flex-col 2xl:mx-4': !inPopup,
        'flex-col': inPopup,
      }"
    >
      <Gauge class="h-[110px] xs:max-h-[130px] xl:max-h-auto" :value="0.4" :is-skeleton="true"></Gauge>
      <div
        :class="{
          'w-full items-start pt-4': inPopup,
          'items-center xl:h-[130px] xs:h-[180px] md:mr-4 2xl:mr-8': !inPopup,
        }"
        class="xl:text-4 flex flex-col xs:pt-5 xl:pt-0 xs:text-5 xl:text-left text-[#4F4F4F]"
      >
        <div class="xs:px-4 md:px-0">
          <div class="w-[85px] h-[10px] loading-gradient mobile:w-[125px]"></div>
        </div>
        <div
          :class="{
            'w-full': inPopup,
          }"
        >
          <MetricBreakdown
            :class="{
              'xl:pt-3 xs:px-4': inPopup,
              'pt-2': !inPopup,
            }"
            :in-popup="inPopup"
          ></MetricBreakdown>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
}
</style>
